import { getFirestore } from 'firebase/firestore/lite'
import { firebaseApp } from './firebase-init'

export const storeDb = getFirestore(firebaseApp)
